import { Injectable } from '@angular/core';
import { TenantLanguage } from '@app/tenant-language/models/tenant-language.model';
import { HttpService } from '@avenir-client-web/http';
import { ListResponse } from '@avenir-client-web/models';
import { languageApi } from '@shared/constants/api.constants';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TenantLanguageService {
  constructor(private readonly httpService: HttpService) {}

  getList(): Observable<TenantLanguage[]> {
    return this.httpService
      .get<ListResponse<TenantLanguage>>(languageApi)
      .pipe(map(response => response.data));
  }
}
